<template>
    <b-row>
        <b-col cols="12">
            <b-card>
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="p-1">
                        <form class="" @submit.prevent="submitForm">
                            <div class="row">
                                <div class="form-group col-12 col-md-4">
                                    <label for="phone24">Incidencia:</label>
                                    <b-form-input v-model="corrective_maintenance.description" autocomplete="off"/>
                                    <span v-if="validation_corrective_maintenance.description" class="text-danger">
                                      {{ validation_corrective_maintenance.description }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput} from 'bootstrap-vue'
import {mapState} from "vuex"
import {VHE_CORRECTIVE_MAINTENANCE_INCIDENT_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
    getterType: 'auxiliaries2CorrectiveMaintenanceVhe/getField',
    mutationType: 'auxiliaries2CorrectiveMaintenanceVhe/updateField',
})

export default {
    name: "FormView",
    components: {
        BCol,
        BRow,
        BCard,
        BFormInput,
        BOverlay,
    },
    data() {
        return {
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('auxiliaries2CorrectiveMaintenanceVhe', ['validation_corrective_maintenance']),
        ...mapFields({
          corrective_maintenance: 'corrective_maintenance',
        }),
    },
    created() {
        this.$store.commit('auxiliaries2CorrectiveMaintenanceVhe/RESET_STATE')
        this.$store.commit('auxiliaries2CorrectiveMaintenanceVhe/CLEAR_VALIDATION')

        if (this.$route.params.id) {
            this.edit = true
            this.getCorrectiveMaintenance()
        } else {
            this.edit = false
        }
        this.$root.$refs.auxiliariesCorrectiveMaintenanceForm = this
    },
    methods: {
      getCorrectiveMaintenance() {

            this.showLoading = true

            this.$store.dispatch('auxiliaries2CorrectiveMaintenanceVhe/findCorrectiveMaintenance', {
                id: this.$route.params.id ?? this.corrective_maintenance.id
            })
                .then(response => {
                  this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                })
        },
        cancel() {
            this.$router.push(VHE_CORRECTIVE_MAINTENANCE_INCIDENT_LIST)
        },
        createAuxiliar() {
            this.$store.dispatch('auxiliaries2CorrectiveMaintenanceVhe/createCorrectiveMaintenance', this.corrective_maintenance)
                .then(response => {
                    helper.showToast('Incidencia creada correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(VHE_CORRECTIVE_MAINTENANCE_INCIDENT_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al crear la incidencia', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        updateAuxiliar() {
            this.$store.dispatch('auxiliaries2CorrectiveMaintenanceVhe/updateCorrectiveMaintenance', this.corrective_maintenance)
                .then(response => {
                    helper.showToast('Incidencia editada correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(VHE_CORRECTIVE_MAINTENANCE_INCIDENT_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al editar la incidencia', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        submitForm() {
            if (this.$route.params.id) {
                this.updateAuxiliar()
            } else {
                this.createAuxiliar()
            }
        },
    },
}
</script>
